import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { WishlistMoveFromBasketComponent } from '../catalog/ui/wishlist/wishlist-move-from-basket.component';
import { ListingLabelComponent } from '../common/listing-label/listing-label.component';
import { ActionComponent } from '../ui/api/action.component';
import { ResultComponent } from '../ui/api/result.component';
import { BasketItemAbstract } from './basket-item.abstract';
import { ItemQtyComponent } from './item-qty.component';

@Component({
    selector: 'minibasket-item',
    templateUrl: './minibasket-item.component.html',
    standalone: true,
    imports: [
        ActionComponent,
        CommonModule,
        DfImageDirective,
        ItemQtyComponent,
        OptionLabelPipe,
        ListingLabelComponent,
        PriceComponent,
        ResultComponent,
        RouterModule,
        TranslatePipe,
        forwardRef(() => WishlistMoveFromBasketComponent)
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MinibasketItemComponent extends BasketItemAbstract {}
